export const EXACT_MATCH = 'disease-game-exact-match';
export const PARTIAL_MATCH = 'disease-game-partial-match';
export const NO_MATCH = 'disease-game-no-match';

export const getComparisonClass = (guessValue, targetValue, isExactMatch = true) => {
  if (isExactMatch) {
    return guessValue === targetValue ? EXACT_MATCH : NO_MATCH;
  }
  // For partial matches (like etiology categories)
  const guessLower = guessValue.toLowerCase();
  const targetLower = targetValue.toLowerCase();
  if (guessLower === targetLower) return EXACT_MATCH;
  if (guessLower.includes(targetLower.split(' ')[0]) || targetLower.includes(guessLower.split(' ')[0])) {
    return PARTIAL_MATCH;
  }
  return NO_MATCH;
};

const splitRoutes = (vector) => vector.split('/').map(route => route.trim().toLowerCase());

// Vectors can list several routes separated by "/", e.g. "Blood/Body fluids".
// Same set of routes in any order is exact; any shared or related route is partial.
export const getVectorComparisonClass = (guessVector, targetVector) => {
  const guessRoutes = splitRoutes(guessVector);
  const targetRoutes = splitRoutes(targetVector);

  const sameRoutes =
    guessRoutes.every(route => targetRoutes.includes(route)) &&
    targetRoutes.every(route => guessRoutes.includes(route));
  if (sameRoutes) return EXACT_MATCH;

  const anyRelated = guessRoutes.some(guessRoute =>
    targetRoutes.some(targetRoute => getComparisonClass(guessRoute, targetRoute, false) !== NO_MATCH)
  );
  return anyRelated ? PARTIAL_MATCH : NO_MATCH;
};
